import { StyleSheet } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(
  ({ colors, spacing, border }, { insets }) => ({
    container: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      zIndex: 1,
      gap: spacing(4),
      paddingTop:
        insets.top +
        spacing(2) +
        CustomPlatform.select({
          android: spacing(2),
          web: spacing(2),
          default: 0,
        }),
      paddingBottom: CustomPlatform.select({
        android: spacing(3),
        default: spacing(2),
      }),
      paddingLeft: {
        xs: spacing(4) + insets.left,
        lg: spacing(6) + insets.left,
      },
      paddingRight: {
        xs: spacing(4) + insets.right,
        lg: spacing(6) + insets.right,
      },
    },
    headerLeft: {
      flexBasis: "10%",
      flexShrink: 0,
      flexGrow: 0,
      height: "100%",
    },
    button: {
      width: spacing(11),
      height: spacing(11),
      justifyContent: "center",
      alignItems: "center",
    },
    glass: {
      ...StyleSheet.absoluteFill,
      borderRadius: border.radius.full,
      justifyContent: "center",
      alignItems: "center",
    },
    buttonIcon: {
      height: spacing(6),
      width: spacing(6),
      color: colors.foregroundDefault,
    },
    headerCenter: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    headerRight: {
      flexBasis: "10%",
      flexShrink: 0,
      flexGrow: 0,
      alignItems: "flex-end",
      height: "100%",
    },
    overflow: {
      marginTop: spacing(0.5),
    },
    overflowIcon: {
      color: colors.foregroundDefault,
      width: spacing(8),
      height: spacing(8),
    },
    overflowItemIcon: {
      color: colors.foregroundDefault,
      width: spacing(6),
      height: spacing(6),
    },
  }),
);

export default stylesheet;
